import {Component, Vue} from 'vue-property-decorator';
import * as api from '@/store/api';
import DokumentWrapper from '@/pdf/DokumentWrapper';

@Component
export default class Webreport extends Vue {
    doc: any | null = null;
    loaded: boolean = false;

    async loadDocument() {
        const documentId = this.$route.params.DocumentId;
        this.doc = new DokumentWrapper(await api.getWebreport(documentId));
        this.doc.isPrint = false;
        this.loaded = true;
    }
}
